import { lazy, Suspense, useEffect, useRef, useState } from "react";
const VideoReviews = lazy(() => import("./VideoReviewsSection"));
/** Keep the original section DOM once loaded; don't ship its carousel at entry. */
export default function DeferredVideoReviews(props: { embedded?: boolean; className?: string }) {
  const marker = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!marker.current) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: "400px" });
    observer.observe(marker.current);
    return () => observer.disconnect();
  }, []);
  return visible ? <Suspense fallback={null}><VideoReviews {...props} /></Suspense> : <div ref={marker} aria-hidden="true" />;
}
